import { Checkbox, Menu } from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import { BiChevronDown } from 'react-icons/bi';
import { shallowEqual, useSelector } from 'react-redux';
import { Button } from 'src/components';
import useFetch from 'src/hooks/useFetch';
import { RootState } from 'src/redux/reducers';
import Service from 'src/setup/network';
import { oneDayAgoDate, todayDate } from 'src/utils/dateOneMonthAgo';
import { formatDateTime } from '../kds';
import DateRangePickerWithTime from './test';

interface categoryDataEach {
  categoryInfo: {
    id: number | null;
    name: string;
  };
}

const ItemSales = () => {
  const { data: categoryData } = useFetch('/categories');
  const [categories, setCategories] = useState<categoryDataEach[]>([]);
  const { settingData } = useSelector(
    ({ settingData }: RootState) => settingData,
    shallowEqual
  );
  const businessName = settingData?.businessInfo?.name;
  const businessAddress = settingData?.businessInfo?.address;
  const pan = settingData?.businessInfo?.pan;
  const [items, setItems] = useState([]);
  const [startDate, setStartDate] = useState<any>(oneDayAgoDate);
  const [endDate, setEndDate] = useState<any>(todayDate());
  const [dateQuery, setDateQuery] = useState<any>(
    `from=${startDate?.toISOString()}&to=${endDate?.toISOString()}`
  );
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [status, setStatus] = useState<categoryDataEach[]>([]);
  const openDisc = Boolean(anchorEl);

  useEffect(() => {
    const cats: categoryDataEach[] = [...(categoryData?.categories ?? [])];
    cats.unshift({ categoryInfo: { id: 1, name: 'All' } });
    setCategories(cats);
  }, [categoryData]);

  const handleClickDiscMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseDiscMenu = () => {
    setAnchorEl(null);
  };

  const handlePrintReport = () => {
    const prtContent = document.getElementById(`item-sales-print`);
    if (!prtContent) return;
    const printWindow = window.open(
      '',
      '',
      'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0'
    );
    if (printWindow) {
      printWindow.document.write(prtContent.innerHTML);
      printWindow.document.close();
      printWindow.focus();
      printWindow.print();
      printWindow.close();
    } else {
      console.error('Failed to open a new window for printing.');
    }
  };

  const allSelected = () => {
    let showAll = false;
    if (status.length === 0) {
      showAll = true;
    } else if (status.length === categories.length) {
      showAll = true;
    }
    return showAll;
  };

  const test = () => {
    return (
      <div id="item-sales-print" className="text-black w-[300px]">
        <div>
          <div
            className="w-[100%] h-[100%]"
            style={{
              display: 'flex',
              flexDirection: 'column',
              fontFamily: 'Arial',
              fontWeight: '400',
            }}
          >
            <div
              className="d-flex flex-column"
              style={{ fontFamily: 'Arial', fontWeight: '400' }}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                }}
              >
                <span
                  style={{
                    fontSize: '16px',
                    lineHeight: '18px',
                    marginBottom: '5px',
                    textTransform: 'uppercase',
                  }}
                >
                  {businessName}
                </span>
                <span
                  style={{
                    fontSize: '12px',
                    lineHeight: '14px',
                    marginBottom: '5px',
                    textTransform: 'uppercase',
                  }}
                >
                  {businessAddress?.area} {businessAddress?.city}
                </span>
                {pan && (
                  <span
                    style={{
                      fontSize: '12px',
                      lineHeight: '14px',
                      marginBottom: '5px',
                      textTransform: 'uppercase',
                    }}
                  >
                    PAN : {pan}
                  </span>
                )}
                <span
                  style={{
                    fontSize: '12px',
                    lineHeight: '14px',
                    marginBottom: '5px',
                  }}
                >
                  ITEM SALES REPORT
                </span>
              </div>
              <span
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  marginTop: '10px',
                  fontSize: '12px',
                  lineHeight: '14px',
                  marginBottom: '5px',
                }}
              >
                <span>
                  Date: {formatDateTime(startDate)} - {formatDateTime(endDate)}
                </span>
              </span>
              <span
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  marginTop: '10px',
                  fontSize: '12px',
                  lineHeight: '14px',
                  marginBottom: '5px',
                }}
              >
                <span>
                  Filter:{' '}
                  {allSelected()
                    ? 'All'
                    : status
                        .filter((item: any) => item.categoryInfo.id !== 1)
                        .map((item: any) => item.categoryInfo.name)
                        .join(', ')}
                </span>
              </span>
              <div></div>
              <div
                style={{
                  margin: '10px 0',
                  borderTop: '2px solid #000',
                }}
              />
              <div
                style={{
                  display: ' grid',
                  gridTemplateColumns: 'repeat(4, 1fr)',
                  marginBottom: '10px',
                  fontSize: '12px',
                  lineHeight: '14px',
                  textTransform: 'uppercase',
                }}
              >
                <div style={{ gridColumn: 'span 2' }}>Item</div>
                <div>Qty</div>
                <div>Total</div>
              </div>
              <div style={{}}>
                {items?.map((each: any, i: number) => {
                  return (
                    <div
                      style={{
                        display: ' grid',
                        gridTemplateColumns: 'repeat(4, 1fr)',
                        marginBottom: '10px',
                        fontSize: '12px',
                        lineHeight: '14px',
                      }}
                    >
                      <div style={{ gridColumn: 'span 2' }}>
                        {each.hasVariants
                          ? `${each.name || each.itemName} (${
                              each.variantName
                            })`
                          : `${each.name || each.itemName}`}{' '}
                      </div>
                      <div className="ml-[1px]">{each.quantity}</div>
                      <div>{each.totalPrice}</div>
                    </div>
                  );
                })}
              </div>
              <div
                style={{
                  margin: '10px 0',
                  borderTop: '2px solid #000',
                }}
              />
              <div
                style={{
                  margin: '10px 0',
                  borderTop: '1px solid #000',
                }}
              />
            </div>
          </div>
        </div>
      </div>
    );
  };

  function removeObjectById(array: any[], id: any) {
    const arrayRet: any = array.filter(
      (item) => item.categoryInfo.id !== id.categoryInfo?.id
    );
    return arrayRet;
  }

  const handleCheckbox = (event: any, i: number) => {
    event.stopPropagation();
    const selected = categories?.[i];
    if (selected.categoryInfo.id === 1) {
      // All
      if (status.length === categories.length) return setStatus([]);
      setStatus(categories);
      return;
    }
    if (!selected) return;
    let statuses: any = [...status];
    statuses = removeObjectById(status, { categoryInfo: { id: 1 } });
    const alreadyPresent = status.find(
      (x: any) => x.categoryInfo?.id === selected.categoryInfo?.id
    );
    if (alreadyPresent) {
      setStatus(removeObjectById(statuses, alreadyPresent));
      return;
    }
    statuses.push({
      categoryInfo: {
        id: selected.categoryInfo?.id,
        name: selected.categoryInfo?.name,
      },
    });
    if (statuses.length === categories.length) statuses = categories;
    setStatus(statuses);
  };

  useEffect(() => {
    let statusJoined = status
      .map((item: any) => item.categoryInfo.id)
      .join(',');
    if (statusJoined.length === 0) statusJoined = '';
    fetchData(`?${dateQuery}&categories=${statusJoined}`);
  }, [status, dateQuery]);

  const fetchData = useCallback(async (querySend: string) => {
    try {
      const res = await Service.get(
        `/payments/receipt/items/summary${querySend}`
      );
      const data = (await res?.data?.items) ?? [];
      setItems(data);
    } catch (err) {}
  }, []);

  return (
    <>
      <div className="pb-10 flex flex-col gap-4">
        <div className="flex gap-2 items-center ml-auto">
          <Button
            text={
              <div className="flex items-center justify-between w-[160px]">
                <span className="line-clamp-1">
                  {allSelected()
                    ? 'All'
                    : status
                        ?.filter((item: any) => item.categoryInfo.id !== 1)
                        .map((item: any) => item.categoryInfo.name)
                        .join(', ')}
                </span>
                <BiChevronDown size={18} className="min-w-6" />
              </div>
            }
            id="basic-button"
            aria-controls={openDisc ? 'basic-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={openDisc ? 'true' : undefined}
            // @ts-ignore
            onClick={handleClickDiscMenu}
          />
          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={openDisc}
            onClose={handleCloseDiscMenu}
            MenuListProps={{
              'aria-labelledby': 'basic-button',
            }}
            PaperProps={{
              style: {
                boxShadow: 'none',
                marginTop: '5px',
                border: '1px solid #4062FF',
                height: 'fit-content',
                backgroundColor: '#FFFFFF',
                overflowY: 'auto',
              },
            }}
          >
            {categories?.map((each: any, i: number) => (
              <div
                key={'payment' + i}
                className={`font-Outfit px-2 py-2 hover:bg-almost-white font-normal text-[14px] leading-6  cursor-pointer `}
              >
                <Checkbox
                  checked={
                    status?.findIndex(
                      (x: any) => x.categoryInfo?.id === each.categoryInfo?.id
                    ) >= 0
                  }
                  onClick={(e) => handleCheckbox(e, i)}
                />
                {each.categoryInfo?.name}
              </div>
            ))}
          </Menu>
          {DateRangePickerWithTime(
            fetchData,
            status,
            setDateQuery,
            setStartDate,
            setEndDate
          )}
          <Button onClick={handlePrintReport} text="Print Report" />
        </div>
        {test()}
      </div>
    </>
  );
};

export default ItemSales;
